
/* styles */
require("!!../../../../.2.1.0@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../.11.3.4@vue-loader/lib/style-compiler/index?{\"id\":\"data-v-5aa26ea4\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../.1.0.61@vux-loader/src/style-loader.js!../../../../.11.3.4@vue-loader/lib/selector?type=styles&index=0!./index.vue")

var Component = require("!../../../../.11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../.11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5aa26ea4\"}!../../../../.1.0.61@vux-loader/src/template-loader.js!../../../../.11.3.4@vue-loader/lib/selector?type=template&index=0!./index.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/.2.2.1@vux/src/components/inline-desc/index.vue
// module id = 87
// module chunks = 1